import React, { useState } from 'react'
import moment from 'moment/moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './CloneEncounterDateModal.scss'
import { addYears, subYears } from 'date-fns'
import GenericConfirmModal from '../../../census/components/ConfirmationModals/GenericConfirmModal'
import { CButton } from '@coreui/react-pro'

export default function CloneEncounterDateModal({ onClose, onChange }) {
  const [date, setDate] = useState(new Date())
  const [visibleDate, setVisibleDate] = useState(new Date())

  const goToToday = () => {
    const today = new Date()

    setDate(today)
    setVisibleDate(today)
  }

  return (
    <GenericConfirmModal
      title={
        <div className={'clone-header position-relative w-100 text-center'}>
          <CButton
            color={'primary'}
            size="sm"
            style={{ left: 0, bottom: '-4px' }}
            onClick={goToToday}
          >
            Today
          </CButton>
          Create new visit on
        </div>
      }
      content={
        <div
          className={'CloneEncounterDateModal'}
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <DatePicker
            selected={date}
            onChange={setDate}
            openToDate={visibleDate}
            onMonthChange={setVisibleDate}
            minDate={subYears(new Date(), 1)}
            maxDate={addYears(new Date(), 1)}
            inline
            fixedHeight
          />
        </div>
      }
      onClose={onClose}
      confirmTxt={'Done'}
      onConfirm={() => {
        onChange(moment(date).format('YYYY-MM-DD'))
      }}
    />
  )
}
